import { Injectable } from '@angular/core';
import { SubcategoryResults, CategoryResults, Results, QuestionResults } from 'src/models/interfaces';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';

@Injectable({
	providedIn: 'root',
})
export class ResultService {
	_sum = 0;
	workAreas:Array<SubcategoryResults>;
	public _subcategoryScore(_subCategory: SubcategoryResults) {
		this._sum = 0;
		this._sum = _subCategory.questions.reduce((a, b) => ({id: 0, score: a.score + b.score})).score;
		return (this._getAverage(this._sum, _subCategory.questions.length))*50;
	}

	public _getCategoryAverage(_category: CategoryResults) {
		this._sum = 0;
		this._sum = _category.subcategories.reduce((a, b) => ({id: 0, score: a.score + b.score, questions: []})).score;
		return this._getAverage(this._sum, _category.subcategories.length);
	}

	public _overallScore(_results: Results) {
		return this._getAverage(_results.categories.reduce((a , b) => ({id: '0', score: a.score + b.score, subcategories: []})).score, _results.categories.length);
	}

	public _getAverage(_sum: number, _div: number) {
		return _sum / _div;
	}

	public _generateReport(_category: CategoryResults) : SubcategoryResults []{
		this.workAreas = _category.subcategories.slice(0,3);
		this.orderArray();
		for(let i = 3; i < _category.subcategories.length; i++) {
			if(_category.subcategories[i].score < this.workAreas[0].score) {
				this.workAreas[0] = _category.subcategories[i];
				this.orderArray();
			}
		}
		return this.workAreas;
	}

	private orderArray() {
		this.workAreas.sort((a,b) => a.score - b.score);
	}

	public sendMail(url: string, email: string, name: string) {
		const send = firebase.functions().httpsCallable('sendReport');
		return send({
			name: name,
			email: email,
			url: url
		});
	}

	public _getOptionalScores(_subcategory: SubcategoryResults) {
		let _viabilityQ:Array<QuestionResults> = [];
		let _opportunityQ:Array<QuestionResults> = [];
		let sumA:number, sumB:number;
		switch (_subcategory.id) {
			case 2:
				for(let _q of _subcategory.questions) {
					if(_q.id == 63 || _q.id == 64 || _q.id == 67) {
						_viabilityQ.push(_q);
					} else {
						_opportunityQ.push(_q);
					}
				}
				break;
			case 3:
				for(let _q of _subcategory.questions) {
					if(_q.id == 13 || _q.id == 14 || _q.id == 16) {
						_viabilityQ.push(_q);
					} else {
						_opportunityQ.push(_q);
					}
				}
				break;
			case 4:
				for(let _q of _subcategory.questions) {
					if(_q.id == 17 || _q.id == 19) {
						_viabilityQ.push(_q);
					} else {
						_opportunityQ.push(_q);
					}
				}
				break;
			case 5:
				for(let _q of _subcategory.questions) {
					if(_q.id == 20 || _q.id == 23 || _q.id == 26 || _q.id == 27 || _q.id == 28) {
						_viabilityQ.push(_q);
					} else {
						_opportunityQ.push(_q);
					}
				}
				break;
			case 6:
				for(let _q of _subcategory.questions) {
					if(_q.id == 30) {
						_viabilityQ.push(_q);
					} else {
						_opportunityQ.push(_q);
					}
				}
				break;
			default:
				break;
		}
		sumA = _viabilityQ.reduce((a, b) =>( {id: 0, score: a.score + b.score})).score * 50;
		sumB = _opportunityQ.reduce((a, b) =>( {id: 0, score: a.score + b.score})).score * 50;
		return [this._getAverage(sumA, _viabilityQ.length), this._getAverage(sumB, _opportunityQ.length)];
	}

}
